import React, { Component } from 'react';
import settings from 'assets/svg/settings.svg';
import channels from 'assets/svg/channels.svg';
import email from 'assets/svg/email.svg';
import SvgRender from 'components/helpers/SvgRender';
import TimeAgo from 'react-timeago';
import ReactDOM from 'react-dom';

import { Dropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import { Formik, Form } from 'formik';
import { Input } from 'reactstrap';

class Channel extends Component {
  constructor() {
    super();

    this.state = {
      isOpen: false,
      rename: false
    };
  }

  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);

    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        rename: false
      });
    }
  };

  render() {
    const { channel } = this.props;
    const { rename } = this.state;

    return (
      <div className="card" key={channel.payload}>
        <div className="card-body p-0">
          <Dropdown
            className="settings drop-container"
            isOpen={this.state.isOpen}
            toggle={this.toggle}
          >
            <DropdownToggle className="border-0 drop-title" tag="a">
              <SvgRender path={settings} style={{ height: 15 }} />
            </DropdownToggle>
            <DropdownMenu right tag="li">
              {this.props.type == 'email' ? (
                <DropdownItem tag="a" className="reverse" disabled>
                  Forgot email
                </DropdownItem>
              ) : (
                <DropdownItem
                  tag="a"
                  className="reverse"
                  onClick={() => {
                    this.props.onUntrust(channel._id);
                  }}
                  disabled={channel.trusted_at ? false : true}
                >
                  Untrust Device
                </DropdownItem>
              )}
              <DropdownItem
                tag="a"
                className="reverse"
                onClick={() => this.setState({ rename: true })}
              >
                Rename
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>

          <div className="card-icon mt-7 d-flex justify-content-center">
            {this.props.type == 'email' ? (
              <SvgRender
                className="justify-content-center"
                path={email}
                style={{ width: 38, marginTop: 5 }}
              />
            ) : (
              <SvgRender
                className="justify-content-center"
                path={channels}
                style={{ width: 38, marginTop: 5 }}
              />
            )}
          </div>
          <div className="mt-3 info-warper px-4">
            {rename ? (
              <Formik
                initialValues={{ payload: channel.alias ? channel.alias : channel.payload }}
                onSubmit={(values, actions) => {
                  this.setState({ rename: false });
                  this.props.onUpdate({
                    _id: channel._id,
                    alias: values.payload
                  });
                }}
                render={({ values, setFieldValue }) => (
                  <Form className="form-group--search d-flex align-items-center mb-1">
                    <Input
                      name="payload"
                      type="text"
                      value={values.payload}
                      className=""
                      onChange={e => {
                        setFieldValue('payload', e.target.value);
                      }}
                    />
                  </Form>
                )}
              />
            ) : (
              <div>{channel.alias ? channel.alias : channel.payload}</div>
            )}
            <div className="last-used">
              Last used: <TimeAgo date={channel.last_used} />
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <div className="trust-wraper d-flex">
              <div className="devider mt-4" />
            </div>
          </div>
          <div className="d-flex justify-content-center">
            {this.props.type == 'email' ? (
              <div className="trust-wraper mt-3 d-flex">
                <div className={`flex-grow-1 text-left ${channel.verified ? 'trusted' : ''}`}>
                  Verified
                </div>
                <div>Default</div>
              </div>
            ) : (
              <div className="trust-wraper mt-3 d-flex">
                <div className={`flex-grow-1 ${channel.trusted_at ? 'trusted' : 'untrusted'}`}>
                  {!channel.trusted_at ? 'Untrusted' : 'Trusted'}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Channel;



// WEBPACK FOOTER //
// ./src/components/helpers/Channel.js